
import { Vue } from "vue-class-component";

export default class IcsOWallet extends Vue {}
